<script>
  export let obj;
  export let state;
  export let i;
  console.log(obj);
  let x = null;

  function ControlAnimation() {
    console.log("obj");
    console.log(obj);

    x = !x;
  }

  function triggerAnimation() {
    let elem = document.getElementById("tasktestWrapperID1");
    elem.style.color = "red";
    elem.style.minHeight = "10rem";
    elem.style.maxHeight = "13rem";
  }

  function untriggerAnimation() {
    let elem = document.getElementById("tasktestWrapperID1");
    elem.style.maxHeight = "0rem";
    elem.style.minHeight = "0rem";
  }
</script>

<div class="openTasks_header">
  <h5>{state} <span on:click={ControlAnimation}>(See All)</span></h5>
  <div on:click={ControlAnimation} class="openTasks_icon">
    {#if x == false}
      <i class="bx bx-down-arrow-circle" />
    {:else}<i class="bx bx-up-arrow-circle" />{/if}
  </div>
</div>

<div class={x === true ? "fullView" : "minimizedView"} id="tasktestWrapperID1">
  {#each obj as [id, task]}
    <!-- {i} -->
    {#if task.status.orderindex == i}
      <a href="/TaskItemDetails/{id}" class="openTasks">
        <div class="taskItem_Wrapper">
          <div class="u-taskName">
            <h6 class="mutedText">Task Name</h6>
            <h5>{task.name}</h5>
          </div>

          <div class="u-taskPriority">
            <h6 style="text-align:center;" class="mutedText">Messages</h6>
            <div class="u-comments" class:unread={task.unread}>
              {Object.entries(task?.messages || {})?.length || 0}
            </div>
          </div>

          <div class="u-taskPriority">
            <h6 style="text-align:center;" class="mutedText">Priority</h6>
            {#if task.priority}
              <div
                style="color:var(--priority{task.priority.name})"
                class="priorityContainer"
              >
                <div
                  style={task.priority.name == "low"
                    ? "transform:rotate(180deg)"
                    : ""}
                  class="arrow"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style="fill:var(--priority{task.priority.name})"
                      d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z"
                    />
                  </svg>
                </div>
                <h5>{task.priority.name}</h5>
              </div>
            {/if}
          </div>

          <div class="u-taskStatus">
            <div
              style="background-color:#2C8F73;color:white"
              class="buttonStatus"
            >
              <div>Pending</div>
            </div>
          </div>
        </div>
      </a>
      <!-- {:else}
            <h1>No tasks found</h1> -->
    {/if}
  {/each}
</div>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(44, 143, 115, 0.35);
  }

  .openTasks_header {
    display: flex;
    /* margin-bottom: 1rem;
        margin-top: 1rem; */
  }

  .openTasks_header h5 {
    font-weight: 400;
    font-size: 1.1em;
    text-transform: capitalize;
  }

  .openTasks_header h5 span {
    color: #8ab3f4;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.8em;
  }

  .openTasks_icon {
    margin-left: 0.5rem;
    cursor: pointer;
  }

  .openTasks {
    margin-top: 1rem;
  }

  .taskItem_Wrapper {
    display: flex;
    flex-direction: row;
    /* background-color: red; */
    background: white;
    justify-content: space-between;
    border-radius: 24px;
    padding: 1rem;
    padding-left: 3rem;
    padding-right: 3rem;
    margin-top: 1rem;
  }

  .taskItem_Wrapper .u-taskName {
    color: black;
  }

  .u-taskPriority {
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .u-taskName {
    width: 33%;
    display: flex;
    flex-direction: column;
  }

  .mutedText {
    color: #91929e;
    margin-bottom: 0.4rem;
    font-weight: 400;
    font-size: 0.8em;
  }

  .priorityContainer {
    display: flex;
    color: #ffbd21;
    text-transform: capitalize;
  }

  .u-taskStatus {
    /* background-color: red; */
    display: flex;
    width: 33%;
    align-items: center;
    justify-content: flex-end;
  }

  .taskItem_Wrapper h5 {
    font-weight: 500;
    font-size: 1em;
  }

  .buttonStatus {
    padding: 0.3rem 0.85rem;
    border-radius: 8px;
    font-weight: 400;
    font-size: 1em;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(44, 143, 115, 0.35);
  }

  .arrow {
    height: 25px;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(44, 143, 115, 0.35);
  }

  .fullView {
    max-height: 20rem;
    /* min-height: 8rem; */
    transition: all 650ms;
    overflow-x: hidden;
  }

  .minimizedView {
    max-height: 0rem;
    /* min-height: 0rem; */
    transition: all 650ms;
    overflow-x: hidden;
  }

  .tasktestWrapper1 {
    min-height: 0rem;
    max-height: 0rem;
    overflow-x: hidden;
    transition: all 650ms;
  }

  .u-comments {
    background-color: #2c8f7332;
    color: #2c8f73;
    padding: 0.1rem 0.25rem;
    border-radius: 40%;
  }

  .unread {
    background-color: #ffe6e4;
    color: #f16063;
  }
</style>
